/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { addMinutes, format } from "date-fns";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

import { parseISO } from "date-fns";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getSubModulesByRoleId,
  reviewInvoice,
} from "../../../store";

import "../../../index.css";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForCreatePo = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 0,
  pt: 3,
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  overflow: "scroll",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const PastReview = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  reviewInvoice,
  reviewInvoiceReducer,
  createDynamicColumn,
  getDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails?.data?.roleId;
  let userId = loginDetails?.data?.userId;
  let roleName = loginDetails?.data?.roleName;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "b64fd710-f26e-43ba-b9a8-09a133af6343";

  let pastReviewAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "b64fd710-f26e-43ba-b9a8-09a133af6343",
  );

  let viewHistoryAccess = pastReviewAccess
    ? pastReviewAccess.actionId.includes("edbb6e5d-252a-457b-a599-ab2637a7efeb")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    reviewInvoice(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [roleName, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      { Header: "PO No.", accessor: "purchaseOrderNumber" },
      { Header: "PO LineNo.", accessor: "purchaseOrderLineNumber" },
      { Header: "Invoice Id", accessor: "invoiceId" },
      { Header: "Invoice No", accessor: "invoiceNo" },
      { Header: "Due Date", accessor: "dueDate" },
      { Header: "Total Amount", accessor: "totalAmount" },
      // { Header: "Status", accessor: "status" },
      { Header: "Create Date", accessor: "cd" },

      // {
      //   Header: "Action",
      //   accessor: "action",
      //   align: "center",
      //   cannotSearch: true,
      // },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [isErrorForCreateOrder, setIsErrorForCreateOrder] = useState(false);
  const [isSuccessForCreateOrder, setIsSuccessForCreateOrder] = useState(false);

  useEffect(() => {
    if (isErrorForCreateOrder) {
      setTimeout(() => {
        setIsErrorForCreateOrder(false);
      }, 3000);
    }
  }, [isErrorForCreateOrder]);

  useEffect(() => {
    if (isSuccessForCreateOrder) {
      setTimeout(() => {
        setIsSuccessForCreateOrder(false);
      }, 3000);
    }
  }, [isSuccessForCreateOrder]);
  const [isErrorRelease, setIsErrorRelease] = useState(false);
  const [isSuccessRelease, setIsSuccessRelease] = useState(false);

  useEffect(() => {
    if (isErrorRelease) {
      setTimeout(() => {
        setIsErrorRelease(false);
      }, 3000);
    }
  }, [isErrorRelease]);

  useEffect(() => {
    if (isSuccessRelease) {
      setTimeout(() => {
        setIsSuccessRelease(false);
      }, 3000);
    }
  }, [isSuccessRelease]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempRows = [];

    const listState = reviewInvoiceReducer;

    const data = Array.isArray(listState?.data?.data)
      ? listState.data.data
      : [];
    const pagination = listState?.data?.pagination || null;

    setPaginationObj(pagination);
    setLoading(listState?.loading);

    data.forEach((inv) => {
      const rawDue = inv?.dueDate ? parseISO(inv.dueDate) : null;
      const localDue = rawDue
        ? addMinutes(rawDue, rawDue.getTimezoneOffset())
        : null;
      const dueDateText = localDue ? format(localDue, "do MMMM yyyy") : "NA";

      const rawCd = inv?.cd ? parseISO(inv.cd) : null;
      const localCd = rawCd
        ? addMinutes(rawCd, rawCd.getTimezoneOffset())
        : null;
      const createdDateText = localCd ? format(localCd, "do MMMM yyyy") : "NA";

      const rowObject = {
        invoiceId: inv.invoiceId,
        purchaseOrderNumber: inv.purchaseOrderNumber,
        purchaseOrderLineNumber: inv.purchaseOrderLineNumber,
        invoiceNo: inv.invoiceNo,
        totalAmount: inv.totalAmount,
        dueDate: dueDateText,
        cd: createdDateText,
      };

      tempRows.push(rowObject);
    });

    setState((prev) => ({ ...prev, rows: tempRows }));
  }, [roleName, reviewInvoiceReducer, viewHistoryAccess]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [disableButton, setDisableButton] = useState(false);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      reviewInvoice(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox mt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted
                tableSearch
                showTotalEntries
                noEndBorder
                loading={loading}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                serverSidePagination
                paginationObj={paginationObj}
                pageNoValue={pageNo}
                rowsPerPageValue={rowsPerPage}
                pageNoProp={importPageNo}
                rowsPerPageProp={importRowsPerPage}
                searchProp={importSearch}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                options={{ draggable: false }}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
                disableButton={disableButton}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <Modal
        open={openCreateColumnReorderModal}
        onClose={handleCloseCreateColumnReorderModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ backdropFilter: "blur(5px)" }}
      >
        <MDCard sx={styleForColumnReorder}>
          <MDTypography>Are you sure you want to submit?</MDTypography>
          <MDBox mt={2}>
            <MDButton
              style={{ width: "10rem", marginRight: "0.5rem" }}
              color="info"
              variant="outlined"
              onClick={handleCloseCreateColumnReorderModal}
            >
              Cancel
            </MDButton>
            <MDButton
              style={{ width: "10rem", marginLeft: "0.5rem" }}
              color="success"
              onClick={handleDynamicColumn}
              // disabled={denyButtonName === "Please wait..."}
            >
              Submit
            </MDButton>
          </MDBox>
          <MDBox mt={2}>
            <Collapse in={isSuccessColumnReorder}>
              <Alert
                severity="success"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setIsSuccessColumnReorder(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                Data updated successfully!
              </Alert>
            </Collapse>
            <Collapse in={isErrorColumnReorder}>
              <Alert
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setIsErrorColumnReorder(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {isErrorMsgForColumnReorder}
              </Alert>
            </Collapse>
          </MDBox>
        </MDCard>
      </Modal>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getPurchaseOrderReducer: state.getPurchaseOrderReducer,
    reviewInvoiceReducer: state.reviewInvoiceReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    reviewInvoice: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(reviewInvoice(pageNo, rowsPerPage, searchObject, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PastReview);
